<template>
  <div>
    <ion-grid class="ion-padding-horizontal">
      <ion-card
        v-if="hasAdminChanges"
        class="ion-no-margin ion-margin-vertical"
      >
        <ion-card-content>
          Le bureau a effectué des modifications sur cette journée signalés par
          🚩.

          <template v-if="adminComment">
            <hr />
            <strong>Commentaire bureau</strong>
            <br />
            <span>{{ adminComment }}</span>
          </template>
        </ion-card-content>
      </ion-card>

      <ion-row class="night-toggle">
        <ion-col>
          <ion-toggle
            ref="toggleNights"
            @ionChange="onToggleNight($event.detail.checked)"
            :disabled="disabled"
            :checked="areNightsEnabled"
          ></ion-toggle>
          Activer les nuits
        </ion-col>

        <ion-col
          class="right"
          v-show="dayDetails && Object.keys(dayDetails).length"
        >
          <ion-button fill="outline" size="small" id="open-modal">
            <ion-icon slot="start" :icon="eyeOutline"></ion-icon>
            Détail journée
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-list>
        <!-- Todo: Shitty AF -->
        <ion-item v-if="areNightsEnabled" lines="none">
          <div style="width: 153px"></div>

          <ion-label class="ion-text-center">Jour</ion-label>
          <ion-label class="ion-text-center">Nuit</ion-label>

          <ion-button slot="end" disabled="true" style="visibility: hidden">
            <ion-icon slot="icon-only" :icon="trashOutline"></ion-icon>
          </ion-button>
        </ion-item>

        <ion-item
          v-for="(entry, index) in details"
          :key="index + entry.text"
          lines="none"
        >
          <ion-label v-if="entry.text" class="ion-text-wrap">
            <span v-if="entry.conflict" class="conflict-flag">🚩</span>

            {{ entry.text }}
          </ion-label>

          <ion-input
            v-else
            ref="customOptionInput"
            :value="entry.text"
            placeholder="Entrez un nom..."
            @ionBlur="updateEntryText(entry, $event.target.value)"
          />

          <ion-button
            size="small"
            class="hour-button"
            @click="openHoursPicker(entry, 'day')"
            :disabled="disabled"
          >
            {{ entry.day ? floatToString(entry.day) : '00:00' }}
          </ion-button>

          <ion-button
            v-if="'night' in entry"
            size="small"
            class="hour-button"
            @click="openHoursPicker(entry, 'night')"
            :disabled="disabled"
          >
            {{ entry.night ? floatToString(entry.night) : '00:00' }}
          </ion-button>

          <ion-button
            color="danger"
            size="small"
            slot="end"
            @click="remove(entry)"
            :disabled="disabled"
          >
            <ion-icon slot="icon-only" :icon="trashOutline"></ion-icon>
          </ion-button>
        </ion-item>

        <ion-button
          fill="outline"
          size="small"
          class="add"
          @click="openAddPicker"
          :disabled="disabled"
        >
          Ajouter une activité
        </ion-button>

        <ion-item lines="none">
          <ion-label>Total</ion-label>

          <ion-button size="small" class="hour-button" disabled="true">
            {{ computedTotalDay }}
          </ion-button>

          <ion-button
            v-if="areNightsEnabled"
            size="small"
            class="hour-button"
            disabled="true"
          >
            {{ computedTotalNight }}
          </ion-button>

          <ion-button slot="end" disabled="true" style="visibility: hidden">
            <ion-icon slot="icon-only" :icon="trashOutline"></ion-icon>
          </ion-button>
        </ion-item>

        <!-- Accordion mode (timer mode) -->
        <ion-accordion-group v-if="timeReportsTimerMode">
          <ion-accordion>
            <ion-item slot="header" lines="none">
              <ion-label>
                Total travaillé
                <p>Cliquez pour voir le suivi de journée</p>

                <p v-if="adminTotalDay" class="admin-hours">
                  <span v-if="hasConflict" class="conflict-flag">🚩</span>
                  Heure bureau {{ floatToString(adminTotalDay) }}
                </p>
                <p v-if="adminTotalNight" class="admin-hours">
                  <span v-if="hasConflict" class="conflict-flag">🚩</span>
                  Heure nuit bureau {{ floatToString(adminTotalNight) }}
                </p>
              </ion-label>

              <ion-button size="small" class="hour-button" disabled="true">
                {{ workedTotalDay }}
              </ion-button>

              <ion-button
                v-if="areNightsEnabled"
                size="small"
                class="hour-button"
                disabled="true"
              >
                {{ workedTotalNight }}
              </ion-button>
            </ion-item>

            <div slot="content">
              <ion-item
                v-for="(entry, index) in timerDetails"
                :key="'timer-detail' + index"
                lines="none"
              >
                <ion-label>
                  Créneau
                  {{ floatToString(entry.dayStart) }} -
                  {{ floatToString(entry.dayEnd) }}
                </ion-label>

                <ion-button
                  size="small"
                  class="hour-button"
                  @click="openHoursPicker(entry, 'day', true)"
                  :disabled="disabled"
                >
                  {{ entry.day ? floatToString(entry.day) : '00:00' }}
                </ion-button>

                <!-- We don't handle night for timer details for now, so simply create a fake div with night button width -->
                <div v-if="areNightsEnabled" style="width: 62px"></div>

                <ion-button
                  color="danger"
                  size="small"
                  slot="end"
                  @click="remove(entry, 'timerDetails')"
                  :disabled="disabled"
                >
                  <ion-icon slot="icon-only" :icon="trashOutline"></ion-icon>
                </ion-button>
              </ion-item>
            </div>
          </ion-accordion>
        </ion-accordion-group>

        <!-- Normal item mode (not timer mode) -->
        <ion-item v-else lines="none">
          <ion-label>Total travaillé</ion-label>

          <ion-button
            size="small"
            class="hour-button"
            @click="openTotalsPicker('day')"
            :disabled="disabled"
          >
            {{ workedTotalDay }}
          </ion-button>

          <ion-button
            v-if="areNightsEnabled"
            size="small"
            class="hour-button"
            @click="openTotalsPicker('night')"
            :disabled="disabled"
          >
            {{ workedTotalNight }}
          </ion-button>

          <ion-button slot="end" disabled="true" style="visibility: hidden">
            <ion-icon slot="icon-only" :icon="trashOutline"></ion-icon>
          </ion-button>
        </ion-item>
      </ion-list>
    </ion-grid>

    <DayDetailsModal
      v-if="dayDetails && Object.keys(dayDetails).length"
      :details="dayDetails"
    />
  </div>
</template>
<script>
import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
  IonToggle,
  alertController,
  pickerController,
  toastController,
} from '@ionic/vue';
import { eyeOutline, trashOutline } from 'ionicons/icons';
import utils from '@/services/utils/Utils';
import {
  floatToString,
  stringToFloat,
  generateFiveMinuteIntervals,
} from '@/services/utils/dateUtils';
import DayDetailsModal from './DayDetailsModal.vue';

const POSSIBLE_MINUTES = generateFiveMinuteIntervals();
const getHoursMinutesFor = val => floatToString(val || 0).split(':');

export default {
  components: {
    IonAccordion,
    IonAccordionGroup,
    IonButton,
    IonCol,
    IonGrid,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonRow,
    IonToggle,

    // custom components
    DayDetailsModal,
  },

  setup() {
    return {
      eyeOutline,
      trashOutline,
    };
  },

  props: {
    options: Array,
    disabled: Boolean,
    currentDay: String,
    dayDetails: Object,
    showDaterange: Boolean,
    timeReportsTimerMode: Boolean,

    // sync
    details: Array,
    timerDetails: Array,
    totalDay: Number,
    totalNight: Number,
    adminTotalDay: Number,
    adminTotalNight: Number,
    adminComment: String,
    hasAdminChanges: Boolean,
  },

  emits: [
    'update:details',
    'update:timerDetails',
    'update:totalDay',
    'update:totalNight',
  ],

  data() {
    return {
      areNightsEnabled: false,
    };
  },

  mounted() {
    this.areNightsEnabled = this.totalNight && this.totalNight > 0;
  },

  methods: {
    /**
     * "Commons / Generic" methods
     */

    /**
     * Generic method to add new entry to the details
     */
    addNewEntry(newEntry) {
      const newDetails = this.details;
      newDetails.push(newEntry);
      this.$emit('update:details', newDetails);

      // if input, autofocus on the input
      // nextTick is not working, so use setTimeout instead
      this.setInputFocus();
    },

    setInputFocus() {
      setTimeout(() => {
        if (!this.$refs.customOptionInput) return;

        this.$refs.customOptionInput.$el.setFocus();
      }, 0);
    },

    /**
     * Generic method to create and open a picker
     * @param {Array} columns - The columns to display in the picker
     * @param {Function} fallback - The function to call when the user validates the picker
     * @param {Object} extraOptions - Extra options for the picker
     */
    async openPicker(columns, fallback, extraOptions = {}) {
      const picker = await pickerController.create({
        columns,
        buttons: [
          {
            text: 'Annuler',
            role: 'cancel',
          },
          {
            text: 'Valider',
            handler: fallback,
          },
        ],
        ...extraOptions,
      });

      await picker.present();
    },

    stringToFloat,
    floatToString,

    /**
     * get "change value" from picker, and convert it to float
     * @param element - The changed value from the picker
     */
    pickerValueToFloat(element, prefix = '') {
      return this.stringToFloat(
        element[`${prefix}hours`].value +
          ':' +
          element[`${prefix}minutes`].value,
      );
    },

    /**
     * Get the total for a specific property (day or night)
     * @param hook - The property to sum (day or night)
     */
    getTotalFor(hook) {
      if (!this.details || this.details.length === 0) {
        return this.floatToString(0);
      }

      const total = this.details.reduce((acc, entry) => {
        return acc + (entry[hook] || 0);
      }, 0);

      return this.floatToString(total);
    },

    /**
     * End of "Commons / Generic" methods
     * -------------------------------------------------------------
     */

    /**
     * Open picker to add new entry into the details
     */
    async openAddPicker() {
      const options = JSON.parse(JSON.stringify(this.options || []));

      // if i don't have any options, we directly add a custom entry
      if (!options || options.length === 0) {
        const newEntry = { text: '', day: 0 };

        if (this.showDaterange) {
          newEntry.dayStart = 0;
          newEntry.dayEnd = 0;
        }

        if (this.areNightsEnabled) {
          newEntry.night = 0;

          if (this.showDaterange) {
            newEntry.nightStart = 0;
            newEntry.nightEnd = 0;
          }
        }

        this.addNewEntry(newEntry);

        // don't display the picker
        return;
      }

      // add a custom option at the end of the list
      options.push({ text: 'Personnalisé...', value: 'custom' });

      const columns = [
        { name: 'activity', cssClass: 'picker-opts-right hydrated', options },
      ];

      // fallback function, to add the new entry
      const fallback = element => {
        let value = element.activity.value;

        // if "custom" value selected, don't set text
        const newEntry = { text: value === 'custom' ? '' : value, day: 0 };

        if (this.showDaterange) {
          newEntry.dayStart = 0;
          newEntry.dayEnd = 0;
        }

        if (this.areNightsEnabled) {
          newEntry.night = 0;

          if (this.showDaterange) {
            newEntry.nightStart = 0;
            newEntry.nightEnd = 0;
          }
        }

        this.addNewEntry(newEntry);
      };

      const extraOptions = {
        onDidDismiss: () => {
          // if picker is dismissed, focus on the input
          this.setInputFocus();
        },
      };

      this.openPicker(columns, fallback, extraOptions);
    },

    /**
     * Open the hours picker to update given entry
     *
     * @param entry - The entry to update
     * @param hook the propery to update (day or night)
     */
    async openHoursPicker(entry, hook, isTimerEntry = false) {
      const dateRangeStartKey = hook === 'day' ? 'dayStart' : 'nightStart';
      const dateRangeEndKey = hook === 'day' ? 'dayEnd' : 'nightEnd';

      let [hours, minutes] = getHoursMinutesFor(entry[hook] || 0);
      if (this.showDaterange || isTimerEntry) {
        [hours, minutes] = getHoursMinutesFor(entry[dateRangeStartKey] || 0);
      }

      const columns = utils.generatePickerColumns(
        hours,
        minutes,
        POSSIBLE_MINUTES,
        'start-',
      );

      // add end column if daterange
      if (this.showDaterange || isTimerEntry) {
        [hours, minutes] = getHoursMinutesFor(entry[dateRangeEndKey] || 0);

        const dateColumns = utils.generatePickerColumns(
          hours,
          minutes,
          POSSIBLE_MINUTES,
          'end-',
        );

        columns.push(...dateColumns);

        // add specific css classes to start / end columns (but only hours one)
        // so start / end labels appear once
        columns.forEach(col => {
          if (!col || !col.name) return;
          const cssClass = col.cssClass || '';

          if (col.name.startsWith('start-') && col.name.includes('hours')) {
            col.cssClass = cssClass + ' picker-start';
          }

          if (col.name.startsWith('end-') && col.name.includes('hours')) {
            col.cssClass = cssClass + ' picker-end';
          }
        });
      }

      const fallback = value => {
        const oldValue = entry[hook] || 0;

        // if daterange, update start / end
        if (this.showDaterange || isTimerEntry) {
          entry[dateRangeStartKey] = this.pickerValueToFloat(value, 'start-');
          entry[dateRangeEndKey] = this.pickerValueToFloat(value, 'end-');

          // if night and end < start, we consider that the end is on the next day
          if (entry[dateRangeEndKey] < entry[dateRangeStartKey]) {
            entry[hook] =
              entry[dateRangeEndKey] + 24 - entry[dateRangeStartKey];
          } else {
            // default is end - start
            entry[hook] = entry[dateRangeEndKey] - entry[dateRangeStartKey];
          }
        } else {
          // else only update total
          entry[hook] = this.pickerValueToFloat(value, 'start-');
        }

        // if timer mode actived and not timer entry
        // don't go further, we only update total with timer entries, not details entries
        if (this.timeReportsTimerMode && !isTimerEntry) {
          return;
        }

        // update total by the difference between old and new value
        const valueToAdd = entry[hook] - oldValue;
        const property = hook === 'day' ? 'totalDay' : 'totalNight';
        this.$emit(`update:${property}`, this[property] + valueToAdd);
      };

      this.openPicker(columns, fallback);
    },

    /**
     * Open picker to update the worked total
     * @param hook - The propery to update (day or night)
     */
    async openTotalsPicker(hook) {
      // "worked" day are already formatted as HH:mm
      // so we can directly split them
      const [hours, minutes] = (
        hook === 'day' ? this.workedTotalDay : this.workedTotalNight
      ).split(':');

      const columns = utils.generatePickerColumns(
        hours,
        minutes,
        POSSIBLE_MINUTES,
      );
      const fallback = value => {
        const newTotal = this.pickerValueToFloat(value);

        const prop = hook === 'day' ? 'totalDay' : 'totalNight';
        this.$emit(`update:${prop}`, newTotal);
      };

      this.openPicker(columns, fallback);
    },

    /**
     * Toggle night on hours details
     * @param toggled - ion-picker state
     */
    onToggleNight(toggled) {
      this.areNightsEnabled = toggled;

      // if night enabled, set all "nights" entries to 0
      if (toggled) {
        const newDetails = this.details.map(detail => {
          const newDetail = {
            ...detail,
            night: detail.night || 0,
          };

          if (this.showDaterange) {
            newDetail.nightStart = detail.nightStart || 0;
            newDetail.nightEnd = detail.nightEnd || 0;
          }

          return newDetail;
        });

        this.$emit('update:details', newDetails);
        return;
      }

      // if night disabled, remove all "nights" entries
      const newDetails = this.details.map(detail => {
        const newDetail = {
          text: detail.text,
          day: detail.day,
        };

        if (this.showDaterange) {
          newDetail.dayStart = detail.dayStart;
          newDetail.dayEnd = detail.dayEnd;
        }

        return newDetail;
      });

      this.$emit('update:details', newDetails);
      this.$emit('update:totalNight', 0);
    },

    /**
     * Remove entry from details or timerDetails
     * @param entry - The entry to remove
     * @param key - The key of the array to remove from ('details' or 'timerDetails')
     */
    async remove(entry, key = 'details') {
      const alert = await alertController.create({
        header: 'Confirmation',
        message: 'Voulez-vous vraiment supprimer cette activité ?',
        buttons: [
          {
            text: 'Annuler',
            role: 'cancel',
          },
          {
            text: 'Supprimer',
            role: 'destructive',
            handler: async () => {
              this.deleteEntry(entry, key);

              const toast = await toastController.create({
                message:
                  "Activité supprimée. N'oubliez pas de sauvegarder la journée.",
                duration: 3000,
                position: 'top',
                color: 'success',
              });
              await toast.present();
            },
          },
        ],
      });

      await alert.present();
    },

    /**
     * Internal method to perform the deletion logic
     */
    deleteEntry(entry, key = 'details') {
      const newEntries = this[key];
      const index = newEntries.indexOf(entry);

      if (index > -1) {
        const removed = newEntries.splice(index, 1)[0];

        // remove entry from total

        if (removed.day) {
          const newTotal = this.totalDay - removed.day;
          this.$emit('update:totalDay', newTotal > 0 ? newTotal : 0);
        }

        if (removed.night) {
          const newTotal = this.totalNight - removed.night;
          this.$emit('update:totalNight', newTotal > 0 ? newTotal : 0);
        }
      }

      this.$emit(`update:${key}`, newEntries);
    },

    /**
     * Update the text of an entry (only for custom entries)
     * @param entry - The entry to update
     * @param value - The new value for the entry text
     */
    updateEntryText(entry, value) {
      // if no text, remove entry
      if (!value) {
        this.remove(entry);
        return;
      }

      entry.text = value;
      this.$emit('update:details', this.details);
    },
  },

  computed: {
    hasConflict() {
      return !!this.details && this.details.some(entry => entry.conflict);
    },

    computedTotalDay() {
      return this.getTotalFor('day');
    },

    computedTotalNight() {
      return this.getTotalFor('night');
    },

    workedTotalNight() {
      if (this.timeReportsTimerMode) {
        // always return 0 if timer mode enabled (we don't handle night yet)
        return this.floatToString(0);
      }

      if (this.totalNight) {
        return this.floatToString(this.totalNight);
      }

      // if no totalNight yet, init it
      this.$emit(
        'update:totalNight',
        this.stringToFloat(this.computedTotalNight),
      );

      return this.computedTotalNight;
    },

    workedTotalDay() {
      if (this.totalDay) {
        return this.floatToString(this.totalDay);
      }

      // if no totalDay yet, init it
      this.$emit('update:totalDay', this.stringToFloat(this.computedTotalDay));

      return this.computedTotalDay;
    },
  },

  watch: {
    currentDay() {
      this.areNightsEnabled = this.totalNight && this.totalNight > 0;
    },
  },
};
</script>

<style scoped lang="scss">
hr {
  border: 0;
  border-top: 1px solid #ececec;
}

.night-toggle {
  .plt-ios & {
    margin-bottom: 4px;
  }

  ion-col {
    display: flex;
    align-items: center;
  }

  ion-toggle {
    margin-right: 4px;
  }
}

.right {
  display: flex;
  justify-content: flex-end;
}

.admin-hours {
  font-size: 12px;
  color: #6b7280;
}

ion-list {
  ion-item {
    --border-color: #e5e7eb;
    --border-radius: 4px;
    --border-width: 1px;
    margin-bottom: 8px;
  }
}

ion-accordion {
  border: 1px solid #e5e7eb;
  border-radius: 4px;

  ion-item {
    margin-bottom: 0;
  }

  div[slot='content'] {
    ion-item {
      --border-width: 0;
    }
  }
}

ion-button {
  --color: #715c1d;
  --border-color: #715c1d;
  --border-width: 1px;
  --background: white;
  text-transform: none;

  ion-icon {
    font-size: 16px;
  }

  &.add {
    width: 100%;
    margin: 0;
    margin-bottom: 8px;
  }
}

.hour-button {
  --box-shadow: none;
  --background: #e5e7eb;
  --color: black;
  font-size: 14px;
}
</style>

<!--
  Simply adds "Start" and "End" labels next to wanted columns.
  Non-scoped, else it will not apply correctly.
-->
<style lang="scss">
.picker-col.picker-start::before,
.picker-col.picker-end::before {
  display: block;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  color: #333;
  margin-top: 52px;
}

/* specific labels */
.picker-col.picker-start::before {
  content: 'Début';
}

.picker-col.picker-end::before {
  content: 'Fin';
}

ion-accordion ion-item ion-icon[slot='end'] {
  margin-inline-start: 32px;
  width: 30px;
}
</style>
